import heroImage from 'images/front-page/pathway-hero-1.png';
import heroImageMobile from 'images/front-page/pathway-hero-mobile-1.png';

import _t from 'i18n!nls/front-page';

export const getHeroModuleData = () => {
  return {
    headline: _t('Your path to career growth'),
    description: _t('Get personalized course recommendations and earn recognized credentials to advance your career.'),
    heroImageUrlMobile: heroImageMobile,
    heroImageUrl: heroImage,
    secondaryCta: {
      text: _t('Explore roles'),
      target: '/career-academy',
    },
    imageOverlayCopy: [
      {
        title: _t('Data Analyst'),
        medianSalary: 73083,
        borderColor: '#FAAF00',
        slug: 'data-analyst',
      },
      {
        title: _t('Project Manager'),
        medianSalary: 96774,
        borderColor: '#8040ED',
        slug: 'project-manager',
      },
    ],
  };
};
